import React,{useState,useContext} from 'react';
import {Breadcrumbs,Typography,Link, Box} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import axios from 'axios';
import qs from 'qs';
import { authUser } from '../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import General from './General'


import {llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';

const useStyles = makeStyles((theme) => ({
    textoSelect: {
      '&:hover': {
        color:'#9ccdfa',
      },
      fontSize:1.25+'rem'
    },
}));

const PerfilInicio = () => {
    let history = useHistory();     
    const classes = useStyles();    
    const source = axios.CancelToken.source();    
    const usuID = localStorage.getItem('UsuId');
    const usu = localStorage.getItem('UsuarioNom');            
    const nvl=  localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0;        
    const Dispvo =localStorage.getItem('Dispvo') ;    
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs'    
    const {usuario,guardarUsuario}= useContext(AuthContext);
    const {generales,guardarGenerales}= useContext(GeneralesContext); 
    const[listMuni,setListMuni]= useState([]);
    const[opcion,setOpcion]= useState(3)
    const [espera,setEspera]= useState(false);
    
    React.useEffect(()=>{                                                            
        veriSesion()
        if (nvl===11) {
            setOpcion(1)
        }
        return ()=> {
            source.cancel();
        }          
    },[])
    
    const veriSesion =  () => {            
        let auxValidacion=authUser()
        if(!auxValidacion ||(usu===undefined||usu===''||usu===null)||(nvl===undefined||nvl===''||nvl===null)
            ||(usuID===undefined||usuID===''||usuID===null) )
        {   guardarUsuario([])				
            guardarGenerales([])    
            localStorage.clear();            	             
            history.push("/")	                	
        }
        else
        {   if (usuario.length==0) 
            {   guardarUsuario({Nombre:usu,nivel:nvl});                                                         
            }        
            
            //llamadaListMuni();                                 
            guardarGenerales({...generales,Titulo:'Encuestas'})                                                       
        }   
    }

    function llamadaListMuni()  {            
        const url= `lugar-municipio-tipo`;                            
        const data = qs.stringify({                
            usuario:usuID,              
            estado:process.env.REACT_APP_EDO,                
            tipo:nvl,                        
            idDispositivo:auxDispV,
            });
                    
        function respuesta (aux) 
        {   if (aux[0].Id != -1) 
            {   setListMuni(aux)
            }                                                                      
        }
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
    };

    const selectOpcion =(e,auxValor)=>{
        e.preventDefault();        
        setOpcion(auxValor)
    }

    const miBreacumb=(valor,titulo)=>{
        return(
        <Typography variant="h5" className={classes.textoSelect} 
            color={opcion === valor ? "Primary":'textPrimary'} onClick={e=>selectOpcion(e,valor)}
        >
            {titulo}
        </Typography>
        )
    }

   


    const contenido = opcion === 3 ? <General /> : null  

    return( 
    <div>
       {/*  <Box display="flex" pt={2} pb={1} style={{justifyContent:'center'}}>
            {filtraTipo()}
        </Box> */}
        {contenido}
    </div>
    );
};

export default PerfilInicio;
